__turbopack_context__.v({
  "equipmentField": "vDpWtG_equipmentField",
  "equipmentFieldDisabled": "vDpWtG_equipmentFieldDisabled",
  "equipmentWrapper": "vDpWtG_equipmentWrapper",
  "extras": "vDpWtG_extras",
  "formFieldContainer": "vDpWtG_formFieldContainer",
  "totalEquipmentsPrice": "vDpWtG_totalEquipmentsPrice",
  "totalEquipmentsPriceContent": "vDpWtG_totalEquipmentsPriceContent",
  "totalEquipmentsPriceHintText": "vDpWtG_totalEquipmentsPriceHintText",
  "totalEquipmentsPriceText": "vDpWtG_totalEquipmentsPriceText",
});
